import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import { FiLayers, FiTarget, FiZap } from 'react-icons/fi';
import { Link } from 'react-router-dom';

const TheApproach = () => {
  return (
    <section className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-brand-gray rounded-[3rem] p-12 lg:p-24 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-[30rem] h-[30rem] bg-brand-purple/5 rounded-full blur-[80px]"></div>
          
          <div className="grid lg:grid-cols-2 gap-20 relative z-10">
            <div>
              <span className="text-brand-purple font-black tracking-[0.3em] uppercase text-xs mb-6 block">The RG Difference</span>
              <h2 className="text-4xl lg:text-5xl font-black text-brand-black mb-8">
                Data-Driven. <br />
                <span className="text-brand-purple">Human-Centered.</span>
              </h2>
              <p className="text-lg text-gray-500 font-medium mb-8 leading-relaxed">
                We don't just give you advice; we give you a system. Using the world-renowned GiANT™ methodology, we help you build a leadership culture that is scalable and sustainable.
              </p>
              
              <div className="flex flex-col space-y-6">
                {[
                  { icon: FiLayers, title: "Visual Tools", text: "Complex psychology made simple and memorable." },
                  { icon: FiTarget, title: "Objective Language", text: "Remove the drama from difficult conversations." },
                  { icon: FiZap, title: "Immediate Application", text: "Learn it today. Use it tonight." }
                ].map((feature, i) => (
                  <div key={i} className="flex items-start space-x-4">
                    <div className="mt-1 w-10 h-10 bg-white rounded-lg flex items-center justify-center shadow-sm text-brand-purple flex-shrink-0">
                      <SafeIcon icon={feature.icon} className="w-5 h-5" />
                    </div>
                    <div>
                      <h4 className="text-xl font-bold text-brand-black">{feature.title}</h4>
                      <p className="text-gray-500 text-sm font-medium">{feature.text}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="mt-12">
                <Link to="/about">
                  <button className="bg-brand-black text-white px-8 py-4 rounded-xl font-bold hover:bg-brand-purple transition-all shadow-lg">
                    Discover Our Philosophy
                  </button>
                </Link>
              </div>
            </div>

            <div className="relative">
              <motion.div 
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                className="relative z-10"
              >
                <img 
                  src="https://i.postimg.cc/K8ngzkW3/Image20260130204457.jpg" 
                  alt="Team Collaboration" 
                  className="rounded-3xl shadow-2xl rotate-3 hover:rotate-0 transition-transform duration-500 w-full h-auto object-cover" 
                />
              </motion.div>
              <div className="absolute -bottom-10 -left-10 w-full h-full border-4 border-brand-purple/20 rounded-3xl -z-10 -rotate-3"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TheApproach;